import React, {Component} from 'react'
import {
    FormGroup,
    Input,
    Label,
    Col
  } from 'reactstrap';
import Subtitle from '../../subtitle/Subtitle'
export default props => {
    return (
        <div>
            <Subtitle text="Banco de dados"/>
            <FormGroup row className="my-0">
                <Col xs="12" lg="4">
                    <FormGroup>
                        <Label htmlFor="ip">IP</Label>
                        <Input type="text" id="ip" autoFocus ref={props.inputRef} placeholder="192.168.0.1" defaultValue={props.entity.ip} onChange={event => props.handleChange('ip', event.target.value)}/>
                    </FormGroup>
                </Col>
                <Col xs="12" lg="4">
                    <FormGroup>
                        <Label htmlFor="port">Porta</Label>
                        <Input type="text" id="port" placeholder="3050" defaultValue={props.entity.port} onChange={event => props.handleChange('port', event.target.value)}/>
                    </FormGroup>
                </Col>
                <Col xs="12" lg="4">
                    <FormGroup>
                        <Label htmlFor="database">Nome ou caminho do banco</Label>
                        <Input type="text" id="database" placeholder="/var/lib/THEMIS.fb ou THEMIS" defaultValue={props.entity.database} onChange={event => props.handleChange('database', event.target.value)}/>
                    </FormGroup>
                </Col>
            </FormGroup>
            <FormGroup row className="my-0">
                <Col xs="12" lg="4">
                    <Label htmlFor="vendor">Tipo</Label>
                    <Input type="select" name="vendor" id="vendor" defaultValue={props.entity.vendor} onChange={event => props.handleChange('vendor', event.target.value)}>
                        <option value="">-- Selecionar</option>
                        {props.databases.map(database => <option value={database.value}>{database.label}</option>)}
                    </Input>
                </Col>
                <Col xs="12" lg="4">
                    <Label htmlFor="sqlFolder">Pasta dos scripts</Label>
                    <Input type="text" id="sqlFolder" placeholder="/sql/themis/firebird" key={props.entity.sqlFolder} defaultValue={props.entity.sqlFolder} onChange={event => props.handleChange('sqlFolder', event.target.value)}/>
                </Col>
                <Col xs="12" lg="4">
                    <Label htmlFor="encoding">Encoding</Label>
                    <Input type="text" id="encoding" placeholder="WIN1252" key={props.entity.encoding} defaultValue={props.entity.encoding} onChange={event => props.handleChange('encoding', event.target.value)}/>
                </Col>
            </FormGroup>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/components/migration-form/database/MigrationDatabaseForm.js